export default __webpack_public_path__ + "static/media/papir.1be06dcf.svg";